
import { RESET_UPLOAD_EMERGENCY_ORDER ,UPLOAD_EMERGENCY_ORDER_ERROR,UPLOAD_EMERGENCY_ORDER_SUCCESS,UPLOAD_EMERGENCY_ORDER_REQUEST,RESET_UPLOAD_EMERGENCY_ERROR} from "../actions/action-type";


const initalState = {
    uploadEmergencyOrderResponse: [],
    isuploadEmergencyOrderError: false,
    isuploadEmergencyOrderSuccess: false,
    isuploadEmergencyOrderLoading: false
};

const uploadEmergencyOrderReducer = (state = initalState, { type, uploadEmergencyOrderResponse }) => {
    switch (type) {
        case UPLOAD_EMERGENCY_ORDER_REQUEST:
            return {
                ...state,
                isuploadEmergencyOrderLoading: true,
                isuploadEmergencyOrderError: false,
                isuploadEmergencyOrderSuccess: false
            };
        case UPLOAD_EMERGENCY_ORDER_SUCCESS:
            return {
                ...state,
                uploadEmergencyOrderResponse: uploadEmergencyOrderResponse,
                isuploadEmergencyOrderLoading: false,
                isuploadEmergencyOrderError: false,
                isuploadEmergencyOrderSuccess: true,
            };
        case UPLOAD_EMERGENCY_ORDER_ERROR:
            return {
                ...state,
                isuploadEmergencyOrderLoading: false,
                isuploadEmergencyOrderError: true,
                isuploadEmergencyOrderSuccess: false
            };
            case RESET_UPLOAD_EMERGENCY_ORDER:            
            return {...state,
                uploadEmergencyOrderResponse:[]
            }
            case RESET_UPLOAD_EMERGENCY_ERROR:            
            return {
                ...state,
                isuploadEmergencyOrderError: false,
                isuploadEmergencyOrderSuccess:false
              };                   
        default:
            return state;
    }
};

export default uploadEmergencyOrderReducer;